import { TicketListItem } from 'models/link/Link';
import { TaskInbox } from 'models/link/Task';

function getOverviewStatus(status: string) {
    const normalizedStatus = status.toLowerCase();
    if (normalizedStatus.includes('cancel') || status.includes('ยกเลิก')) {
        return 'ถูกยกเลิก';
    }
    if (
        normalizedStatus.includes('checkout') ||
        normalizedStatus.includes('finish') ||
        normalizedStatus.includes('complete') ||
        status.includes('ปิดงาน')
    ) {
        return 'ปิดงานแล้ว';
    }

    return 'กำลังดำเนินการ';
}

export function mapTaskInboxToTicket(task: TaskInbox, linkId: string): TicketListItem {
    const overviewStatus = getOverviewStatus(task.status ?? '');

    return {
        aobjectlink: task.key,
        ticketNO:
            task.tkno || task.ticket_no || task.business_object || task.document_number || '-',
        ticketDetail: task.detail ?? '',
        jobdescription: task.subject ?? '',
        projectcategory: task.prj_desc ?? '',
        checkIn_Date: task.checkin_date || task.start_date || '',
        checkIn_Time: task.checkin_time || task.start_time || '',
        creator: task.created_by_name || task.created_by || '',
        empcode: linkId,
        leader: task.first_assign ?? '',
        leaderEN: task.first_assign_name || task.first_assign || '',
        activityStatus: task.status ?? '',
        activityOverviewStatus: overviewStatus,
        taskStatusDesc: task.task_status_name || overviewStatus,
        taskStatusPercent: task.task_status_percentage || '0',
        priority: task.priority_description ?? '',
        haste: task.haste_description ?? '',
        show_radius: task.subject ?? '',
        additionalField: []
    };
}
